import {CoinsProductInterface} from "@/modules/action-points/interfaces";

export default class WebMockCoinsProduct implements CoinsProductInterface {
  constructor(
    public coins: number,
    public price: number,
    public name: string,
    public description?: string,
  ) {}
}
